/* eslint-disable import/no-cycle */
import { IRoute, RouterItemPg } from 'viggo-sistemas-core-web';
import {
  filterGrantMenuItens,
  ordemAlfabetica
} from '../menu.service';

export class MenuSysadmin {
  constructor() {}

  /**
   * Cria o menu lateral de Localização
   * @param routes Rotas pemitidas ao usuário
   */
  createLocalizacaoMenu(routes: IRoute[]) {
    let menu: RouterItemPg;
    let submenu = [] as RouterItemPg[];

    submenu = filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Mesoregiões',
          icon: 'pi pi-fw pi-map',
          routerLink: ['/mesorregioes'],
          idElement: 'menu-mesoregiao'
        },
        matchBackendRoutes: [{ url: '/mesorregioes/<id>', method: 'PUT' }]
      },
      {
        menuItem: {
          label: 'Microregiões',
          icon: 'pi pi-fw pi-map',
          routerLink: ['/microrregioes'],
          idElement: 'menu-microregiao'
        },
        matchBackendRoutes: [
          {
            url: '/microrregioes/<id>',
            method: 'PUT'
          }
        ]
      },
      {
        menuItem: {
          label: 'Municípios',
          icon: 'pi pi-fw pi-map',
          routerLink: ['/municipios'],
          idElement: 'menu-municipio'
        },
        matchBackendRoutes: [
          {
            url: '/municipios/<id>',
            method: 'PUT'
          }
        ]
      },
      {
        menuItem: {
          label: 'Regiões',
          icon: 'pi pi-fw pi-map',
          routerLink: ['/regioes'],
          idElement: 'menu-regiao'
        },
        matchBackendRoutes: [
          {
            url: '/regioes/<id>',
            method: 'PUT'
          }
        ]
      },
      {
        menuItem: {
          label: 'Países',
          icon: 'pi pi-fw pi-map',
          routerLink: ['/paises'],
          idElement: 'menu-pais'
        },
        matchBackendRoutes: [
          {
            url: '/paises/<id>',
            method: 'PUT'
          }
        ]
      },
      {
        menuItem: {
          label: 'UFs',
          icon: 'pi pi-fw pi-map',
          routerLink: ['/ufs'],
          idElement: 'menu-uf'
        },
        matchBackendRoutes: [{ url: '/ufs/<id>', method: 'PUT' }]
      }
    ]);

    submenu.sort(ordemAlfabetica);

    if (submenu.length > 0)
      menu = {
        label: 'Localização',
        icon: 'pi pi-fw pi-map',
        routerLink: null,
        idElement: 'menu-localizacao',
        items: submenu
      };
    return menu;
  }
}
